import { createActions, createReducer } from 'reduxsauce'
import { fromJS } from 'immutable'

const { Types, Creators } = createActions(
  {
    request: ['key', 'api', 'args', 'options'],
    success: ['key', 'payload'],
    failure: ['key', 'error'],
    clear: ['key'],
    set: ['key', 'data']
  },
  { prefix: 'react-commons/' }
)

export const creators = Creators
export const types = Types

const INITIAL_STATE = fromJS({})

const request = (state, { key }) => state.mergeDeep({ [key]: { loading: true } })
const success = (state, { key, payload }) => state.merge({ [key]: { data: payload, loading: false } })
const failure = (state, { key, error }) => state.merge({ [key]: { error: error, loading: false } })
const clear = (state, { key }) => state.delete(key)
const set = (state, { key, data }) => state.mergeDeep({ [key]: { data } })

export const reducer = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.CLEAR]: clear,
  [Types.SET]: set
})
